module.exports = __webpack_public_path__ + "img/back-button.53ced001.svg";